import React from 'react';
import { useSignedUser } from 'api/auth';
import { useHistory } from 'react-router-dom';
import { Role } from 'api/types/auth';
import { Spin } from 'antd';

export const LoginGuard = ({ children }: { children: React.ReactNode }) => {
  const { data: user, isLoading } = useSignedUser();
  const history = useHistory();

  if (!isLoading && user && user.owner_id !== null && user.role === Role.HOST) {
    return children;
  }

  // If a guest user tries to access a host page, redirect to login
  if (!isLoading && user && user.owner_id === null && user.role === Role.GUEST) {
    history.push('/login');
  }

  if (!isLoading && !user) {
    history.push('/login');
  }

  return <Spin />;
};
